/* Home FAQ accordion (sections/home-faq.liquid) — reproduces the Shogun motion:
   open = 200ms height slide, then the answer fades in over 500ms; close = 200ms slide with the answer visible.
   Without this file the <details name> elements still work natively (single-open, no animation).
   The name attribute moves to data-group so the script, not the browser, closes the other items. */
(function () {
  if (window.__homeFaq) return;
  window.__homeFaq = true;

  var EASE = 'cubic-bezier(.02,.01,.47,1)';
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)');

  function adopt(root) {
    (root || document).querySelectorAll('details.hfaq__item[name]').forEach(function (d) {
      d.dataset.group = d.getAttribute('name');
      d.removeAttribute('name');
    });
  }

  function toggle(d, open) {
    var summary = d.querySelector('summary');
    var answer = d.querySelector('.hfaq__a');
    if (reduce.matches || !d.animate) { d.open = open; return; }
    d.getAnimations().forEach(function (a) { a.cancel(); });
    if (answer) answer.getAnimations().forEach(function (a) { a.cancel(); });
    var from = d.offsetHeight;
    if (open) { d.open = true; if (answer) answer.style.opacity = 0; }
    var to = open ? d.offsetHeight : summary.offsetHeight + (d.offsetHeight - d.clientHeight);
    d.animate({ height: [from + 'px', to + 'px'] }, { duration: 200, easing: EASE }).onfinish = function () {
      if (!open) { d.open = false; return; }
      if (answer) {
        answer.style.opacity = '';
        answer.animate({ opacity: [0, 1] }, { duration: 500, easing: 'linear' });
      }
    };
  }

  function openOnly(d) {
    if (d.dataset.group) {
      document.querySelectorAll('details.hfaq__item[data-group="' + d.dataset.group + '"]').forEach(function (o) {
        if (o !== d && o.open) toggle(o, false);
      });
    }
    toggle(d, true);
  }

  document.addEventListener('click', function (e) {
    var summary = e.target.closest('.hfaq__q');
    if (!summary) return;
    var d = summary.parentElement;
    e.preventDefault();
    if (d.open) toggle(d, false); else openOnly(d);
  });

  // Theme editor: re-adopt re-rendered sections and open the question being edited.
  document.addEventListener('shopify:section:load', function (e) { adopt(e.target); });
  document.addEventListener('shopify:block:select', function (e) {
    if (e.target.matches && e.target.matches('details.hfaq__item') && !e.target.open) openOnly(e.target);
  });

  adopt();
})();
